import type { IconData } from '@stacksjs/iconify-core'

export const entertainmentGym: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m16 3l-3-3a3.536 3.536 0 0 1-5 0L6 2l3 3l-4 4l-3-3l-2 2a3.536 3.536 0 0 1 0 5l3 3a3.536 3.536 0 0 1 5 0l2-2l-3-3l4-4l3 3l2-2a3.536 3.536 0 0 1 0-5\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default entertainmentGym
